// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3wzaz","header":"ReportDetails_header__QYW1_","title":"ReportDetails_title__3iekK","left":"ReportDetails_left__2b5G2"};